(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

jQuery(function ($) {
  console.log(sbl_data);
  $('body').on('asl_location_found', function (event, selected_location) {
    var sliderContainers = $('.sbl_loader');
    var data = {};
    data.action = 'get_current_location';
    data.current_location = selected_location !== null && selected_location !== void 0 ? selected_location : -1;
    sliderContainers.each(function (ind, ele) {
      data.current_location = $(this).attr('data-region-id');
      jQuery.ajax({
        type: "POST",
        url: sbl_data.url,
        data: data,
        success: function success(response) {
          if (response !== data.current_location) {
            location.reload();
          }
        }
      });
    });
  });
});

},{}]},{},[1]);
